// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtClaimSubmitClaimResultModelResponse {
    static getAttributeTypeMap() {
        return ExtClaimSubmitClaimResultModelResponse.attributeTypeMap;
    }
}
ExtClaimSubmitClaimResultModelResponse.discriminator = undefined;
ExtClaimSubmitClaimResultModelResponse.additionalProperties = false;
ExtClaimSubmitClaimResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtClaimSubmitClaimResultModel"
    },
];
//# sourceMappingURL=extClaimSubmitClaimResultModelResponse.js.map